import React, { useContext, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../contexts/Auth";
import { LanguageContext } from "../../../contexts/Language";
import { browserLanguage, hasLanguageChoice, rememberLanguageChoice } from "../../../utils/languageUtils";
import { Clickable } from "../../button/Clickable";
import { Icon } from "../../graphic/Icon";
import { switchSitePathLanguage } from "../../../utils/siteRoutes";
import styles from "./SiteLanguageSuggestion.scss";

const msgKey = "siteLanguageSuggestion";

/**
 * Bar above the navbar that suggests the page in the browser's language, e.g. /no/pricing for a Norwegian browser on
 * /pricing. Instead of redirecting, so every language can be found by search engines. Shown until the visitor picks.
 */
export const SiteLanguageSuggestion = () => {
    const intl = useIntl();
    const location = useLocation();
    const { me, busyAuthenticating } = useContext(AuthContext);
    const { pageLanguage, setLanguage } = useContext(LanguageContext);
    const [dismissed, setDismissed] = useState(hasLanguageChoice);
    const suggested = browserLanguage();

    // Only on pages with the language in the URL, and not for logged in users (they have their own language)
    if (!pageLanguage || me || busyAuthenticating || dismissed || suggested.locale === pageLanguage.locale) {
        return null;
    }

    const handleSwitch = () => {
        rememberLanguageChoice(suggested);
        setLanguage(suggested);
    };

    const handleClose = () => {
        rememberLanguageChoice(pageLanguage);
        setDismissed(true);
    };

    // The suggestion is written in the suggested language
    return (
        <div className={styles.base}>
            <div className={styles.inner}>
                <p className={styles.text} lang={suggested.ietf}>
                    <FormattedMessage id={`${msgKey}.${suggested.locale}.text`} />
                </p>
                <Clickable
                    link={`${switchSitePathLanguage(location.pathname, suggested.locale)}${location.search}${location.hash}`}
                    onClick={handleSwitch}
                    className={styles.switch}
                >
                    <span lang={suggested.ietf}>
                        <FormattedMessage id={`${msgKey}.${suggested.locale}.switch`} />
                    </span>
                    <Icon name="arrow-right" />
                </Clickable>
            </div>
            <button
                type="button"
                className={styles.close}
                aria-label={intl.formatMessage({ id: `${msgKey}.close` })}
                onClick={handleClose}
            >
                <Icon name="close" />
            </button>
        </div>
    );
};
